'use client';

import React from 'react';
import clientConfig from '../../client/config';
import styles from './CoverImage.module.scss';
import { useIsPageOwner } from '../../hooks/useIsPageOwner';
import { usePage } from '../Providers/PageProvider';
import { useTranslation } from 'react-i18next';

export const ChangeCover: React.FC = () => {
  const { t } = useTranslation();
  const isPageOwner = useIsPageOwner();
  const { slug } = usePage();

  if (!isPageOwner) {
    return null;
  }

  return (
    <a
      className={styles.actionButton}
      href={`${clientConfig.justGivingRootUrl}/${slug}/admin/edit`}
    >
      {t('cover.change')}
    </a>
  );
};
